export default function ({ store, route, $log }) {
  const logger = $log.create('Route MW')
  logger.debug('Start')
  logger.debug(`Changed route to ${route.path}`)
  store.commit('page/CLOSE_MOBILE_MENU')

  if (process.browser) {
    // Route change in the browser will be a user navigating to a new page - dismiss cookie notice
    if (!store.getters['page/cookiesChecked']) {
      store.dispatch('session/UPDATE', { allow_cookies: 'dismiss' })
      store.commit('page/SET_COOKIE_STATUS', true)
    } else {
      store.dispatch('session/UPDATE', {}) // Track the latest page
    }

    store.dispatch('session/TRACK', { event: 'CHANGE_PAGE', body: route.path })
  }
  logger.debug('Finish')
}